
import {browserIsHide} from './utils/bowderIsHiden'
import { setWaterMark, removeWatermark } from './utils/watermark'
import AlertModule from 'vux/src/plugins/alert/module'

export default {
name: 'App',
created() {
console.log('browserIsHide:', browserIsHide())
if (browserIsHide() === false) {

AlertModule.show({
title: this.$t('com_waring_title'),
content: this.$t('com_alert_content'),
onShow () {
},
onHide () {

history.back()
}
})
}
},
mounted () {





},
methods:{
}
}



// WEBPACK FOOTER //
// ./src/App.vue